import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=25dfb857&scoped=true"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=js"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=js"
import style0 from "./GlobalSnackbar.vue?vue&type=style&index=0&id=25dfb857&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dfb857",
  null
  
)

export default component.exports